export default (callback, timeoutMs = 120000) => {
  let timeoutId;
  const resetTimer = () => {
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(callback, timeoutMs);
  };

  document.addEventListener("mousemove", resetTimer, { passive: true });
  document.addEventListener("keypress", resetTimer);
  document.addEventListener("touchmove", resetTimer);
  resetTimer();
};



// WEBPACK FOOTER //
// ./src/util/onInactivity.js